export function addViewportResizeListeners(onResize, options = {}) {
  const {
    includeWindowResize = true,
    includeOrientationChange = true,
    includeVisualViewportResize = true,
    includeVisualViewportScroll = false,
  } = options;

  if (typeof window === 'undefined' || typeof onResize !== 'function') {
    return () => {};
  }

  let frameId = null;
  let lastSnapshot = null;
  const visualViewport = window.visualViewport;

  const getSnapshot = () => ({
    innerWidth: window.innerWidth,
    innerHeight: window.innerHeight,
    devicePixelRatio: window.devicePixelRatio || 1,
    visualViewportWidth: visualViewport ? visualViewport.width : null,
    visualViewportHeight: visualViewport ? visualViewport.height : null,
    visualViewportScale: visualViewport ? visualViewport.scale : null,
  });

  const hasSnapshotChanged = (nextSnapshot, prevSnapshot) => {
    if (!prevSnapshot) {
      return true;
    }

    return Object.keys(nextSnapshot).some((key) => nextSnapshot[key] !== prevSnapshot[key]);
  };

  const flush = () => {
    frameId = null;
    const nextSnapshot = getSnapshot();
    if (!hasSnapshotChanged(nextSnapshot, lastSnapshot)) {
      return;
    }

    lastSnapshot = nextSnapshot;
    onResize(nextSnapshot);
  };

  const scheduleResize = () => {
    if (frameId !== null) {
      window.cancelAnimationFrame(frameId);
    }
    frameId = window.requestAnimationFrame(flush);
  };

  if (includeWindowResize) {
    window.addEventListener('resize', scheduleResize);
  }

  if (includeOrientationChange) {
    window.addEventListener('orientationchange', scheduleResize);
  }

  if (visualViewport && includeVisualViewportResize) {
    visualViewport.addEventListener('resize', scheduleResize);
  }

  if (visualViewport && includeVisualViewportScroll) {
    visualViewport.addEventListener('scroll', scheduleResize);
  }

  return () => {
    if (frameId !== null) {
      window.cancelAnimationFrame(frameId);
    }

    if (includeWindowResize) {
      window.removeEventListener('resize', scheduleResize);
    }

    if (includeOrientationChange) {
      window.removeEventListener('orientationchange', scheduleResize);
    }

    if (visualViewport && includeVisualViewportResize) {
      visualViewport.removeEventListener('resize', scheduleResize);
    }

    if (visualViewport && includeVisualViewportScroll) {
      visualViewport.removeEventListener('scroll', scheduleResize);
    }
  };
}
